export default __webpack_public_path__ + "static/media/community-garden.106ccc65.png";